var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-dropdown-item",
        {
          attrs: { type: "button", disabled: _vm.isLoading },
          on: {
            click: function ($event) {
              $event.stopPropagation()
              return _vm.onClickBookmark(_vm.item)
            },
          },
        },
        [
          _vm.item.isBookmarked
            ? _c("i", { staticClass: "go-icon-18 go-icon-bookmark-on" })
            : _c("i", { staticClass: "go-icon-18 go-icon-bookmark-line" }),
          _vm._v(" "),
          _c("span", { staticClass: "go-text" }, [
            _vm._v(
              _vm._s(
                _vm.$t(
                  "briefing.label." +
                    (_vm.item.isBookmarked
                      ? "remove-to-scrape"
                      : "add-to-scrape")
                )
              )
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }